export const placementTags = [
  'No feature',
  'Featured - category',
  'Featured - lead home page',
] as const;

export enum EMBED_TYPES {
  ZAPIER_TEMPLATE = 'ZapTemplateComponent',
}
